@import '_base.css';

:root {
  --spw-ds-primary: var(--spw-color-themes-purple-purple-500);
  --spw-ds-variant: var(--spw-color-themes-purple-purple-800);
  --spw-ds-active: var(--spw-color-themes-purple-purple-900);
  --spw-ds-cta-outlined-bg-hover: var(--spw-color-themes-purple-purple-50);
  --spw-ds-cta-outlined-stroke-hover: var(--spw-color-themes-purple-purple-700);
  --spw-ds-cta-outlined-bg-active: var(--spw-color-themes-purple-purple-100);
  --spw-ds-cta-outlined-stroke-active: var(--spw-color-themes-purple-purple-800);
}
